import Mock from 'mockjs'

Mock.Random.extend({
  contestType: function (date) {
    let contestType = ['contested', 'recommended', 'unlimited']
    return this.pick(contestType)
  },
  status: function (date) {
    let status = ['pending', 'error', 'pass', 'finish']
    return this.pick(status)
  }
})

const taskInfo = Mock.mock({
  data: {
    title: '@ctitle',
    contest_type: '@contestType',
    apply_start_time: '@date("yyyy/MM/dd")',
    apply_end_time: '@date("yyyy/MM/dd")',
    report_start_time: '@date("yyyy/MM/dd")',
    report_end_time: '@date("yyyy/MM/dd")',
    'groups|3-5': [
      {
        title: '@ctitle',
        'subjects|5-10': ['@cword(2,6)'],
        promotion: '@integer(1,20)'
      }
    ],
    apply_template_url: '@url',
    remark: '@cword(1,500)'
  }
})

const subordinateStatus = Mock.mock({
  data: {
    'claimed|4-8': [
      {
        title: '@ctitle',
        'data|4': [{ title: '@cword(1,4)', status: '@status' }]
      }
    ],
    'unclaimed|3-6': [
      {
        title: '@cword(1,4)',
        status: '@ctitle'
      }
    ],
    'reject|3-6': [
      {
        title: '@cword(1,4)',
        reason: '@title'
      }
    ]
  }
})

export default [
  {
    path: '/api/taskInfo',
    type: 'get',
    response: config => {
      return {
        status: 'success',
        data: taskInfo
      }
    }
  },
  {
    path: '/api/subordinateStatus',
    type: 'get',
    response: config => {
      return {
        status: 'success',
        data: subordinateStatus
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/mocks/modules/taskInfo.js